import { Action } from '@ngrx/store'
import * as UsersTypes from './mobile-users.types'
import { MobileUser } from './mobile-users.interface'

// Fetch Users Actions
export class FetchMobileUsersRequest implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USERS_REQUEST
  constructor(public payload: any) {}
}

export class FetchMobileUsersSuccess implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USERS_SUCCESS
  constructor(
    public payload: MobileUser[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchMobileUsersFailure implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USERS_FAILURE
  constructor(public payload: any) {}
}

// Fetch User Actions
export class FetchMobileUserRequest implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USER_REQUEST
  constructor(public id: number, public property: string) {}
}

export class FetchMobileUserSuccess implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USER_SUCCESS
  constructor(public payload: MobileUser, public property: string) {}
}

export class FetchMobileUserFailure implements Action {
  readonly type = UsersTypes.FETCH_MOBILE_USER_FAILURE
  constructor(public payload: any, public property: string) {}
}

// Delete User Actions
export class DeleteMobileUserRequest implements Action {
  readonly type = UsersTypes.DELETE_MOBILE_USER_REQUEST
  constructor(public id: number) {}
}

export class DeleteMobileUserSuccess implements Action {
  readonly type = UsersTypes.DELETE_MOBILE_USER_SUCCESS
  constructor() {}
}

export class DeleteMobileUserFailure implements Action {
  readonly type = UsersTypes.DELETE_MOBILE_USER_FAILURE
  constructor(public payload: any) {}
}

// Create User Actions
export class CreateMobileUserRequest implements Action {
  readonly type = UsersTypes.CREATE_MOBILE_USER_REQUEST
  constructor(public payload) {}
}

export class CreateMobileUserSuccess implements Action {
  readonly type = UsersTypes.CREATE_MOBILE_USER_SUCCESS
  constructor() {}
}

export class CreateMobileUserFailure implements Action {
  readonly type = UsersTypes.CREATE_MOBILE_USER_FAILURE
  constructor(public payload: any) {}
}

// Update User Actions
export class UpdateMobileUserRequest implements Action {
  readonly type = UsersTypes.UPDATE_MOBILE_USER_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateMobileUserSuccess implements Action {
  readonly type = UsersTypes.UPDATE_MOBILE_USER_SUCCESS
  constructor() {}
}

export class UpdateMobileUserFailure implements Action {
  readonly type = UsersTypes.UPDATE_MOBILE_USER_FAILURE
  constructor(public payload: any) {}
}

// Common Actions
export class UpdateField implements Action {
  readonly type = UsersTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class ReissueActivationCodeRequest implements Action {
  readonly type = UsersTypes.REISSUE_ACTIVATION_CODE_REQUEST
  constructor(public userId: any) {}
}

export class ReissueActivationCodeSuccess implements Action {
  readonly type = UsersTypes.REISSUE_ACTIVATION_CODE_SUCCESS
  constructor(public payload: any) {}
}

export class ReissueActivationCodeFailure implements Action {
  readonly type = UsersTypes.REISSUE_ACTIVATION_CODE_FAILURE
  constructor(public payload: any) {}
}

export class SetDefaultData implements Action {
  readonly type = UsersTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateMobileUserRequest
  | UpdateMobileUserSuccess
  | UpdateMobileUserFailure
  | FetchMobileUserSuccess
  | FetchMobileUserFailure
  | FetchMobileUserRequest
  | CreateMobileUserRequest
  | CreateMobileUserSuccess
  | CreateMobileUserFailure
  | DeleteMobileUserRequest
  | DeleteMobileUserSuccess
  | DeleteMobileUserFailure
  | SetDefaultData
  | UpdateField
  | FetchMobileUsersRequest
  | FetchMobileUsersSuccess
  | FetchMobileUsersFailure
  | ReissueActivationCodeRequest
  | ReissueActivationCodeSuccess
  | ReissueActivationCodeFailure
